// Customer list by service type routes
export const CUSTOMER_LIST_URL_DEFAULT = '/customer-management/list';
export const CUSTOMER_LIST_URL_AUDIT_340B = '/audit-customer-management/list';
export const CUSTOMER_LIST_URL_HEALTH_SYSTEM = '/health-system-management/list';
export const CUSTOMER_LIST_URL_PHARMACY_CHAIN =
  '/pharmacy-chain-management/list';

// Customer details by service type routes
export const CUSTOMER_DETAILS_URL_DEFAULT = '/customer-management/details';
export const CUSTOMER_DETAILS_URL_AUDIT_340B =
  '/audit-customer-management/details';
export const CUSTOMER_DETAILS_URL_HEALTH_SYSTEM =
  '/health-system-management/details';
export const CUSTOMER_DETAILS_URL_PHARMACY_CHAIN =
  '/pharmacy-chain-management/details';
